// extracted by mini-css-extract-plugin
export default {"indicatorIcon":"referralCode_indicatorIcon__AaLW6","slide":"referralCode_slide__8FtQW"};